<template>
  <div class="progress">
    <span
      v-if="actualStep === 1"
      :class="{ 'progress-back__disabled': !hidden }"
    />
    <span v-else :class="{ 'progress-back': !hidden }" @click="previous()" />

    <div class="step-row" :class="{ hidden }">
      <div
        v-for="step in nbStep"
        :key="step"
        class="step"
        :class="{ step__completed: step <= actualStep }"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    nbStep: {
      type: Number,
      required: true,
    },
    actualStep: {
      type: Number,
      required: true,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    previous() {
      this.$emit('previous', this.actualStep - 1);
    },
  },
};
</script>
